<template>
    <div class="modal-chart">
        <div class="modal-chart__legend">
            <p>Основные виды реализуемых услуг/продукции:</p>
            <ul class="list">
                <li class="item" v-for="(e,i) in chartLabels" :key="i">
                    <div :style="{background: bgColorsList[i]}" class="item__marker"></div> 
                    {{e}}
                </li>
            </ul>
        </div>
        <chart ref="modalChart" class="modal-chart__pie no_print" type="pie" :data="chartData" :options="modalPieOptions" />
        <div class="chart-img-for-print" ref="imgContainer"></div>
    </div>
</template>

<script>
import chart from '@/components/ui/chart/chart.vue'

import { getPercent, getImgFromCanvas } from '@/helpers.ts'
import { modalPieOptions } from '@/components/card/tenders/chartOptions.js'

export default {
    components: {
        chart
    },
    props: {
        data: Array
    },
    data() {
        return {
            modalPieOptions,
            bgColorsList: [
                "#bada55",
                "#7fe5f0",
                "#ff0000",
                "#420420",
                "#ffc0cb",
                "#5ac18e",
                "#ffd700",
                "#c6e2ff",
                "#4ca3dd",
                "#696969"
            ]
        }
    },
    computed: {
        totalAmount() { return this.$props.data?.reduce((total, el) => total += el.amount, 0) },
        othersAmount() { return this.$props.data?.slice(9).reduce((total, el) => total += el.amount, 0) },
        chartLabels() {
            return [
                ...this.$props.data?.slice(0, 9)?.map(el => `${(el.title && el.title !== 'unknown') ? el.title : 'Название не указано'}(${getPercent(el.amount, this.totalAmount)}%)`),
                `Прочие(${getPercent(this.othersAmount, this.totalAmount)}%)`
            ]
        },
        chartData() { 
            return {  
                labels: this.chartLabels,
                datasets: [{
                    fill: false,
                    backgroundColor: this.bgColorsList,
                    hoverOffset: 4,
                    data: [...this.$props.data?.slice(0, 9)?.map(el => el.amount), this.othersAmount],
                }]
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                const canvas = this.$refs.modalChart?.$refs?.chart
                const imgContainer = this.$refs.imgContainer

                getImgFromCanvas(canvas, imgContainer)
            }, 1500)
        })
    }
}
</script>

<style lang="sass" scoped>

.chart-img-for-print
    display: none

.modal-chart
    width: 100%
    padding: 10px 50px
    display: flex
    justify-content: space-around
    align-items: center
    overflow-x: hidden
    &__legend
        width: 50%
        p
            margin-bottom: 15px
            font-size: 16px
        .list
            padding: 0
            .item
                font-size: 13px
                margin: 7px 0
                position: relative

                &__marker
                    width: 7px
                    height: 7px
                    border-radius: 50%
                    position: absolute
                    left: -15px
                    top: 5px
    &__pie
        width: 50%
        height: 356px
</style>
